export var ModelStatusRead;
(function (ModelStatusRead) {
    let scope;
    (function (scope) {
        scope["BASELINE"] = "baseline";
        scope["STUDY"] = "study";
    })(scope = ModelStatusRead.scope || (ModelStatusRead.scope = {}));
})(ModelStatusRead || (ModelStatusRead = {}));
